import { jwtDecode } from 'jwt-decode';

// Hook for managing authentication tokens in localStorage or sessionStorage if the user opts to be remembered

export function useAuthStorage() {
  const saveToken = (token, remember) => {
    const storage = remember ? localStorage : sessionStorage;
    storage.setItem('access_token', token);
  };

  const getToken = () =>
    localStorage.getItem('access_token') ||
    sessionStorage.getItem('access_token');

  const clearToken = () => {
    localStorage.removeItem('access_token');
    sessionStorage.removeItem('access_token');
  };

  const isTokenExpired = (token) => {
    try {
      return jwtDecode(token).exp * 1000 <= Date.now();
    } catch {
      return true;
    }
  };

  return { saveToken, getToken, clearToken, isTokenExpired };
}
